/**
 * @file: featureFlags.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const featureFlags = {
  aheadOfTimeTokenRefreshEnabled: true,
};
